// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"f2ad656b","429":"f2ad656b"}[chunkId] + ".chunk.css";
};